<template>
    <Multiselect class="beforeheader" v-model="selectedCostcentres" :options="selectableCostcentres" :placeholder="$trans.get('__JSON__.Default Costcentre')" mode="multiple" :close-on-select="false" :hide-selected="false" @close="refreshForm"/>
    <input v-for="costcentre in selectedCostcentres" type="hidden" name="costcentres[]" :value="costcentre" :key="'cc-' + costcentre">
</template>

<script>

import Multiselect from '@vueform/multiselect';
import getCostcentres from '../composables/costcentres';

export default {
    name: "MultiSelectCostcentre",
    components: {
        Multiselect
    },
    props: {
        selected: Object
    },
    setup(props) {
        const { costcentres, costcentres_error, loadCostcentres } = getCostcentres();
        loadCostcentres();
        console.log('costcentres', costcentres);
        return { costcentres };
    },
    created() {
        this.selectedCostcentres = this.selected;
    },
    data() {
        return {
            selectedCostcentres: null,
        }
    },
    computed: {
        selectableCostcentres() {
            var items = [];
            if (this.costcentres) {
                this.costcentres.forEach(element => {
                    const costcentre = {
                        value: element.costcentre,
                        label: { en: element.name },

                    };
                    items.push(costcentre);
                });
            }
            return items;
        },
    },
    methods: {
        refreshForm() {
            $('#selectForm').attr('method', 'get');
            $('#selectForm').submit();            
        }
    }
}
</script>

<style>
.beforeheader {
    z-index: 120;
}
</style>